import type { Action } from 'redux';

export const APPLY_FILTERS = 'APPLY_FILTERS' as const;

export const applyFilters = () => ({ type: APPLY_FILTERS });

export type ApplyFiltersResponseAction = Action<typeof APPLY_FILTERS>;
